import { useEffect, useState } from 'react';

export const useIsInIframe = (): boolean => {
  const [isInIframe, setIsInIframe] = useState<boolean>(false);

  useEffect(() => {
    const checkIfInIframe = () => {
      try {
        return window.self !== window.top;
      } catch (e) {
        // If accessing window.top throws a security error (due to cross-origin issues), we're likely in an iframe
        return true;
      }
    };

    setIsInIframe(checkIfInIframe());
  }, []);

  return isInIframe;
};
